import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type ThemeMode = "light" | "dark" | "system";

interface ThemeState {
  mode: ThemeMode;
}

const STORAGE_KEY = "luxfair.theme";

function readStored(): ThemeMode {
  if (typeof window === "undefined") return "light";
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (raw === "light" || raw === "dark" || raw === "system") return raw;
  return "light";
}

function applyToDocument(mode: ThemeMode) {
  if (typeof window === "undefined") return;
  const root = window.document.documentElement;
  const resolved =
    mode === "system"
      ? window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light"
      : mode;
  root.classList.toggle("dark", resolved === "dark");
}

const initial: ThemeState = { mode: readStored() };
applyToDocument(initial.mode);

const slice = createSlice({
  name: "theme",
  initialState: initial,
  reducers: {
    setMode(state, action: PayloadAction<ThemeMode>) {
      state.mode = action.payload;
      if (typeof window !== "undefined") {
        window.localStorage.setItem(STORAGE_KEY, action.payload);
      }
      applyToDocument(action.payload);
    },
  },
});

export const { setMode } = slice.actions;
export default slice.reducer;
